module.exports = __webpack_public_path__ + "static/media/zw.bd54e200.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/zw.svg
// module id = 983
// module chunks = 0